module.exports = __webpack_public_path__ + "static/media/video-off.9bce1da6.svg";